import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Sizes, SubArrowDown } from "@/components/icon/IconList";
import { Typography } from "@bookips/sds";
export const PriceRow = (param)=>{
    let { label , amount , variant , showIcon =false , isNegative =false  } = param;
    const formattedAmount = "".concat(isNegative ? "-" : "").concat(amount.toLocaleString(), "원");
    return /*#__PURE__*/ _jsxs("dd", {
        className: "flex justify-between",
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: variant,
                className: "text-secondary",
                children: [
                    showIcon && /*#__PURE__*/ _jsx(Icon, {
                        icon: SubArrowDown,
                        size: Sizes.small,
                        className: "text-secondary"
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: variant,
                className: "text-secondary",
                children: formattedAmount
            })
        ]
    });
};
